export const URL_SIGNALEMENTS = 'https://github.com/reseau-constellation/iug/issues';
export const URL_TÉLÉCHARGEMENTS = 'https://réseau-constellation.ca/#/téléchargements';
export const IPA_TÉLÉCHARGEMENTS = 'https://api.github.com/repos/reseau-constellation/iug/releases';

export const URL_DOCUMENTATION = 'https://docu.réseau-constellation.ca';
export const URL_APPLI = 'https://appli.réseau-constellation.ca';
export const URL_TUTORIELS = 'https://docu.réseau-constellation.ca/exemples/créationCompte.html';
export const URL_COMMUNAUTÉ = 'https://matrix.to/#/!poDYzupTbvLiBsnQSr:matrix.org?via=matrix.org';

export const COURRIEL_SIGNALEMENTS = 'julien.malard@mail.mcgill.ca';

export const MAX_TAILLE_IMAGE = 500 * 1000; // 500 kilooctets

export const GABARIT_CODE =
  'https://github.com/reseau-constellation/gabarits/archive/refs/heads/main.zip';

export const ID_KILIMUKKU_INTERFACE = '/orbitdb/zdpuB2TS5hMwjrYKmCife6WxBFUAG4JiUfR9zct9s8FnH278n';
